import NotFound from '@/views/NotFound.vue'
import LoginLayout from '@/layouts/Login.vue'
import AppLayout from '@/layouts/Main.vue'

export default [
  {
    path: '/',
    redirect: '/Login'
  },
  {
    path: '/',
    component: LoginLayout,
    children: [
      {
        path: 'Login',
        name: 'login',
        component: () => import(/* webpackPrfetch: true */ '@/views/Login.vue')
      },
      {
        path: 'Recovery',
        name: 'recovery',
        component: () => import(/* webpackChunkName: "recovery" */ '@/views/Recovery.vue')
      }
    ]
  },
  {
    path: '/',
    component: AppLayout,
    children: [
      {
        path: 'Home',
        name: 'admin.home',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue')
      },
      {
        path: 'Users',
        name: 'admin.users',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Users.vue')
      },
      {
        path: 'Accounts',
        name: 'admin.accounts',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Accounts.vue')
      },
      {
        path: 'TrailerProfileTemplates',
        name: 'admin.trailerProfileTemplates',
        component: () => import(/* webpackChunkName: "trailer-profiles" */ '@/views/TrailerProfileTemplates.vue')
      },
      {
        path: 'Configurations',
        name: 'admin.configuration',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Configurations.vue')
      },
      {
        path: 'ImportTrailerProfiles',
        name: 'admin.importTrailerProfiles',
        component: () => import(/* webpackChunkName: "home" */ '@/views/ImportTrailerProfiles.vue')
      },
      {
        path: 'Reports',
        name: 'admin.reports',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Reports.vue')
      },
      {
        path: 'VehicleTypes',
        name: 'admin.vehicleTypes',
        component: () => import(/* webpackChunkName: "home" */ '@/views/VehicleTypes')
      },
      {
        path: 'Units',
        name: 'admin.units',
        component: () => import(/* webpackChunkName: "home" */ '@/views/NewUnits')
      },
      {
        path: 'Drivers',
        name: 'admin.drivers',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Drivers')
      },
      {
        path: 'ApiTokens',
        name: 'admin.apiTokens',
        component: () => import(/* webpackChunkName: "home" */ '@/views/ApiTokens')
      },
      {
        path: 'Groups',
        name: 'admin.groups',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Groups')
      },
      {
        path: 'Geofences',
        name: 'admin.geofences',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Geofences')
      },
      {
        path: 'Notifications',
        name: 'admin.notifications',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Notifications')
      },
      {
        path: 'NewReports',
        name: 'admin.newReports',
        component: () => import(/* webpackChunkName: "home" */ '@/views/NewReports')
      },
      {
        path: 'Mechanics',
        name: 'admin.mechanics',
        component: () => import(/* webpackChunkName: "mechanics" */ '@/views/Mechanics')
      },
      {
        path: 'TPMSAlerts',
        name: 'admin.tpmsAlerts',
        component: () => import(/* webpackChunkName: "home" */ '@/views/TPMSAlerts.vue')
      }
    ]
  },
  {
    path: '/',
    component: AppLayout,
    children: [
      {
        path: 'Profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/Profile.vue')
      }
    ]
  },
  {
    path: '*',
    name: 'notfound',
    component: NotFound
  }
]
